export default __webpack_public_path__ + "static/media/michael.660d3e04.jpg";